<template>
    <div class="bg_eef1fa teximg">
        <div class="text_pic">
            <div class="main">
                <div class="text_pic_top_title flex_space_between align_items_center">
                    <p>图文故事</p>
                </div>
                <ul class="flex_space_between flex_wrap">
                    <li class="flex_start" v-for="(item,index) in datalist" @click="goUrl(this,item.id,item.type)">
                        <div class="pic_box">
                            <img :src="item.pic" />
                        </div>
                        <div class="text_box">
                            <h2>{{item.title}}</h2>
                            <p>{{item.intro}}</p>
                            <span class="flex_space_between">
                                <label>{{item.source}}</label>
                                <label>{{item.create_time}}</label>
                                <img src="@/assets/images/like.png" v-if="item.is_like == 0" />
                                <img src="@/assets/images/header_red.png" v-else />
                            </span>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
        <div class="page" v-html="page_html">
        </div>
    </div>
</template>

<script>
    export default {
        name: "teximg",
        data(){
            return {
                page:1,
                datalist: [],
                hot_list: [],
                page_html :''
            }
        },
        created(){
            if(this.$route.query.page) {
                this.page = this.$route.query.page;
            }
            this.listChange('teximg',this.page);
        },
        watch:{
        },
        mounted() {
        },
        methods:{
            listChange: function (type,page) {
                let _this = this;
                _this.page = page;
                this.$http({
                    url: 'index/listInfo',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{page:page,type:'teximg',token:localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1) {
                        _this.datalist = res.data.data.list;
                        _this.page_html = res.data.data.page;
                    } else {
                        layer.msg(res.data.msg);
                    }
                });
            },
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            }
        },
    }
</script>

<style scoped>
    .teximg{padding-bottom: 60px;}
    .text_pic{width:100%;background: #eef1fa;padding-top:45px;position: relative;}
    .text_pic_top{width: 100%;background: #d9ecff;position: absolute;top:0;left:0;height: 225px;}
    .text_pic_top_title{width:100%;padding-left:40px;position: relative;background:#fff;height: 70px;line-height: 70px;margin-bottom: 40px;position: relative;z-index: 2;}
    .text_pic_top_title::before{content:"";position: absolute;top:0;left:0;width: 8px;height: 70px;background:#627eb6;}
    .no_before::before{display: none;}
    .text_pic_top_title p{width: auto;font-size:40px;color:#333;display: block;}
    .text_pic_top_title a{width: auto;font-size:20px;color:#333;display: block;padding-right: 20px;}
    .text_pic ul {position: relative;z-index:2;}
    .text_pic ul li{width: 575px;height: 240px;padding:20px;background:#fff;border-radius: 10px;box-shadow: 0 0 20px rgba(170,176,194,.2);margin-bottom: 40px;}
    .text_pic ul li img,.pic_box{width: 200px;height: 200px;object-fit: cover;display: block;}
    .text_box{width:315px;display: block;margin-left:20px;}
    .text_box h2{width: 100%;font-size:22px;color:#333;line-height: 28px;font-weight: normal;height: 56px;overflow: hidden;}
    .text_box p{width: 100%;font-size:14px;line-height: 21px;color:#666;display: block;margin:10px 0;height: 100px;overflow: hidden; }
    .text_box span label {margin-right: 40px;display: inline-block;color:#666;font-size:14px;line-height: 14px;}
    .text_box span img{width:auto !important;height: 14px !important;object-fit:contain;display:inline-block;}

    .page{max-width: 1200px;margin:15px auto;}


    @media screen and (max-width: 1240px) {

        .text_pic{width: 100%;padding:5.6vw 2% 0;}
        .text_pic ul li{width: 100%;margin-bottom: 3.2vw;}
        .text_box{width: calc(100% - 220px);}
    }
    @media screen and (max-width: 640px) {
        .text_pic_top_title p{font-size:5.25vw;}
        .text_pic_top_title{margin-bottom: 3.2vw;height: 10.9375vw;line-height: 10.9375vw;padding-left:6.25vw;}
        .text_pic_top_title::before{height: 10.9375vw;}
        .text_pic ul li{padding:3.125vw;height: auto;}
        .text_pic ul li img, .pic_box{width: 31.25vw;height: 31.25vw;}
        .text_box{width: calc(100% - 31.25vw - 3.125vw);}
        .text_box h2,.text_box p{height: auto;}
        .text_box{position: relative;}
        .text_box p{margin-bottom: 30px;}
        .text_box span{position: absolute;bottom:0;left:0;width: 100%;}
        .text_box span label{white-space: nowrap;margin-right: 0;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/teximg/index.vue